import Layout from '@/components/feature/Layout';
import CoverageMap from './components/CoverageMap';

export default function CoveragePage() {
  return (
    <Layout>
      {/* Hero header with image background */}
      <div className="relative py-16 md:py-24 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=aerial%20view%20of%20semi%20rural%20neighborhood%20in%20bolivia%20with%20mountains%20in%20distant%20background%2C%20scattered%20houses%20with%20green%20vegetation%20and%20dirt%20roads%2C%20sunny%20day%2C%20warm%20earthy%20natural%20colors%2C%20documentary%20style%20photography%2C%20wide%20landscape%20with%20negative%20space%20for%20text&width=1800&height=600&seq=coverage-hero-aerial&orientation=landscape"
            alt="Vista aérea de San Jacinto Norte Zona Oeste, Tarija"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60" />
        </div>
        <div className="relative z-10 w-full px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-300 mb-3">
            Cobertura
          </span>
          <h1 className="font-heading font-bold text-3xl md:text-5xl text-white mb-4">
            Área de Cobertura
          </h1>
          <p className="text-white/70 text-sm md:text-base max-w-2xl mx-auto">
            Conoce la zona exacta donde CODESAJAN brinda servicio de agua en San Jacinto Norte Zona Oeste.
          </p>
        </div>
      </div>

      {/* Map section */}
      <div className="w-full px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="max-w-5xl mx-auto">
          <CoverageMap />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
            <div className="p-6 rounded-xl bg-background-100 border border-background-200/70">
              <h3 className="font-heading font-semibold text-lg text-foreground-950 mb-3">
                Zona de Cobertura
              </h3>
              <ul className="space-y-2.5">
                {[
                  'San Jacinto Norte Zona Oeste',
                  'Zona Oeste de San Jacinto',
                ].map((zone) => (
                  <li key={zone} className="flex items-center gap-2.5 text-sm text-foreground-700">
                    <i className="ri-map-pin-line text-accent-500 w-4 h-4 flex items-center justify-center"></i>
                    {zone}
                  </li>
                ))}
              </ul>
            </div>

            <div className="p-6 rounded-xl bg-background-100 border border-background-200/70">
              <h3 className="font-heading font-semibold text-lg text-foreground-950 mb-3">
                Datos de la Red
              </h3>
              <div className="space-y-3">
                {[
                  { label: 'Extensión de red', value: '3 km' },
                  { label: 'Familias conectadas', value: '70' },
                  { label: 'Inicio del servicio', value: '2015' },
                  { label: 'Tipo de gestión', value: 'Comité autónomo sin fines de lucro' },
                ].map((item) => (
                  <div key={item.label} className="flex justify-between items-center py-2 border-b border-background-200/50 last:border-0">
                    <span className="text-sm text-foreground-600">{item.label}</span>
                    <span className="text-sm font-semibold text-foreground-950">{item.value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}